__turbopack_context__.v({
  "btn": "_7G5roa_btn",
  "btnFooter": "_7G5roa_btnFooter",
  "cardArticle": "_7G5roa_cardArticle",
  "cards": "_7G5roa_cards",
  "cards2": "_7G5roa_cards2",
  "containerCard": "_7G5roa_containerCard",
  "content": "_7G5roa_content",
  "custom-dot-list-style": "_7G5roa_custom-dot-list-style",
  "headContact": "_7G5roa_headContact",
  "headkutip": "_7G5roa_headkutip",
  "imageContainer": "_7G5roa_imageContainer",
  "p": "_7G5roa_p",
  "page-body-wrap": "_7G5roa_page-body-wrap",
  "pagehero": "_7G5roa_pagehero",
  "paragraph": "_7G5roa_paragraph",
  "paragraph-content": "_7G5roa_paragraph-content",
  "phonecontent": "_7G5roa_phonecontent",
  "react-multi-carousel-dot": "_7G5roa_react-multi-carousel-dot",
  "react-multi-carousel-dot--active": "_7G5roa_react-multi-carousel-dot--active",
  "react-multi-carousel-list": "_7G5roa_react-multi-carousel-list",
  "slider": "_7G5roa_slider",
  "store": "_7G5roa_store",
  "t": "_7G5roa_t",
  "title": "_7G5roa_title",
  "titleSlider": "_7G5roa_titleSlider",
  "wrap-container": "_7G5roa_wrap-container",
  "wrap-content": "_7G5roa_wrap-content",
});
